import React from 'react';
import { HomePage } from './pages/HomePage';
import { LanguageProvider } from './i18n/LanguageContext';
import { LanguageSwitcher } from './components/LanguageSwitcher';
export function App() {
  return <LanguageProvider data-id="element-0">
      <LanguageSwitcher data-id="element-1" />
      <HomePage data-id="element-2" />
    </LanguageProvider>;
}